import React from 'react';
import './styles.css';

const EmptyView = () => (
  <div className='emptyView-wrap'>
    <img src='/images/gif/no-result.gif' alt='no-result gif' />
  </div>
);

export default EmptyView;
